import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <div style={{width:'100%', minHeight:'70px', backgroundColor:'#010201', position:'absolute', top:'0px', display:'flex', marginBottom:'0px'}}>
            <div style={{minWidth:'50%', justifyContent:'flex-start', margin:'15px',  display:'flex'}}>
              <a style={{fontSize:27, cursor:'pointer', textDecoration:'none', color:'white'}} href='/'>Noble Gas Studios</a>
            </div>
              <div style={{minWidth:'35%', justifyContent:'flex-end', margin:'auto', display:'flex'}}>
                <a style={{fontSize:27, cursor:'pointer', margin:'70px', textDecoration:'none', color:'white', margin:'auto'}} href='/about'>About</a>
                <a style={{fontSize:27, cursor:'pointer', textDecoration:'none', color:'white', margin:'auto'}} href='/contact'>Contact</a>
                
              </div>
              
            </div>
      <BrowserRouter>
      <Routes>
      <Route index element={
          <>
            
            

            <div style={{marginBottom:'20px'}}>
              <p style={{fontWeight:600, fontSize:64, marginTop:'15%'}}>Our Games</p>
              <p style={{fontSize:24, marginTop:'-5%'}}>Though we're small and new, we put our all into our work!</p>
            </div>

            <div className='Card' style={{backgroundColor:'black', maxWidth:'60%', borderRadius:'10px', marginTop:'40px'}}>
              <img style={{ height:'5%', width:'90%', borderColor:'#010201', borderRadius:'10px', borderWidth:'20px'}} src='/siteDirectorBanner.png'/>
            </div>

            <p style={{fontSize:24, maxWidth:'40%', marginBottom:'60px'}}><span style={{fontSize:18}}><a style={{textDecoration:'none', color:'white'}} rel='noreferrer' target='_blank' href="https://store.steampowered.com/app/3037990/SCP_Site_Director/"><u>SCP: Site Director</u></a>is an upcoming 2D management game set in the SCP mythos, the player must use their management skills to grow their own SCP Foundation, capture new anomalies, and administrative their facilities. Check out our<a style={{textDecoration:'none', color:'white'}} rel='noreferrer' target='_blank' href="https://discord.com/invite/e3hHfyPaQH"><u>Discord</u></a>!</span> </p>
            
            
          </>
      } />
      <Route path="about" element={
        <>
        <div style={{display:'flex', width:'60%', justifyContent:'center'}}>
          <p style={{margin:'auto', fontWeight:600, fontSize:78}}>Who are we?</p>
          <p style={{margin:'auto', width:'600px', textAlign:'right'}}>We're a small studio based in the United States, led by Hayden Karp. We are currently working to develop our first title SCP: Site Director</p>
        </div>
        </>
      }/>
      <Route path="contact" element={
        <>
          <div style={{display:'flex', width:'60%', justifyContent:'center'}}>
            <p style={{margin:'auto', fontWeight:600, fontSize:78}}>Reach Out!</p>
            <p style={{margin:'auto', width:'800px', textAlign:'right'}}>Email: support@noblegasstudios.com</p>
          </div>
        </>
      }/>
      </Routes>
      </BrowserRouter>
      
      </header>

      <div style={{width:'100%', minHeight:'20px', backgroundColor:'#010201', display:'flex', display:'flex', marginBottom:'0px'}}>
              <div style={{minWidth:'50%', justifyContent:'flex-start', display:'flex'}}>
                <p style={{fontSize:13, margin:'20px', color:'white'}}>Noble Gas Studios - 2024</p>
              </div>
              
              
            </div>
    </div>
  );
}

export default App;
